import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { sortAlphabetically } from "../../utils/sortAlphabetically";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";
export default function AddUnitForm({ open, onClose, onSubmit }) {
  const [unitName, setUnitName] = useState("");
  const [unitId, setUnitId] = useState("");
  const [parentGroup, setParentGroup] = useState("");

  const [notificationGroups, setNotificationGroups] = useState([]);
  const [loadingNotificationGroups, setLoadingNotificationGroups] =
    useState(false);
  const [notificationGroup, setNotificationGroup] = useState("");

  const [leaseNumber, setLeaseNumber] = useState("");
  const [leaseName, setLeaseName] = useState("");
  const [regionDistrict, setRegionDistrict] = useState("");
  const [route, setRoute] = useState("");

  // 🔹 State for groups
  const [groups, setGroups] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(false);

  // 🔹 Validation errors state
  const [errors, setErrors] = useState({});
  const [allRegions, setAllRegions] = useState([]);
  const [loadingRegions, setLoadingRegions] = useState(false);

  const [allRoutes, setAllRoutes] = useState([]);
  const [loadingroutes, setLoadingRoutes] = useState(false);

  const [loading, setLoading] = useState(false);

  // 🔹 Fetch groups on mount
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        setLoadingGroups(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/groups`,
          {
            params: {
              companyId: process.env.REACT_APP_COMPANY_ID,
              type: "geographical",
            },
          }
        );
        const sortedData = sortAlphabetically(response.data, "name");
        setGroups(sortedData);
        //console.log("✅ Groups fetched:", response.data);
      } catch (err) {
        console.error("❌ Error fetching groups:", err);
      } finally {
        setLoadingGroups(false);
      }
    };

    fetchGroups();
  }, []);

  useEffect(() => {
    const fetchNotificationGroups = async () => {
      try {
        setLoadingNotificationGroups(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/groups`,
          {
            params: {
              companyId: process.env.REACT_APP_COMPANY_ID,
              type: "notification",
            },
          }
        );
        const sortedData = sortAlphabetically(response.data, "name");
        setNotificationGroups(sortedData);
        // console.log("✅ Notification groups fetched:", response.data);
      } catch (err) {
        console.error("❌ Error fetching notification groups:", err);
      } finally {
        setLoadingNotificationGroups(false);
      }
    };

    fetchNotificationGroups();
  }, []);

  useEffect(() => {
    if (!parentGroup) {
      setAllRegions([]);
      setRegionDistrict("");
      return;
    }
    const fetchRegions = async () => {
      try {
        setLoadingRegions(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/regions?groupId=${parentGroup}`,
          {
            params: { companyId: process.env.REACT_APP_COMPANY_ID },
          }
        );
        setAllRegions(response.data);
        //console.log("✅ Regions fetched:", response.data);
      } catch (err) {
        console.error("❌ Error fetching regions:", err);
        setAllRegions([]);
      } finally {
        setLoadingRegions(false);
      }
    };

    fetchRegions();
  }, [parentGroup]);

  useEffect(() => {
    if (!regionDistrict) {
      return;
    }
    const fetchRoutes = async () => {
      try {
        setLoadingRoutes(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/routes?regionId=${regionDistrict}`
        );
        setAllRoutes(response.data);
      } catch (err) {
        console.error("❌ Error fetching routes:", err);
      } finally {
        setLoadingRoutes(false);
      }
    };

    if (open) {
      fetchRoutes();
    }
  }, [open, regionDistrict]);

  useEffect(() => {
    setUnitName(
      leaseNumber + (leaseNumber || leaseName ? " " : "") + leaseName
    );
  }, [leaseNumber, leaseName]);

  // 🔹 Validation function
  const validateForm = () => {
    const newErrors = {};

    if (!unitName.trim()) {
      newErrors.unitName = "Unit Name is required";
    }
    if (!unitId.trim()) {
      newErrors.unitId = "Modem Serial Number is required";
    }
    if (!parentGroup) {
      newErrors.parentGroup = "Parent Group is required";
    }
    if (!leaseNumber.trim()) {
      newErrors.leaseNumber = "Unit Number is required";
    }
    if (!leaseName.trim()) {
      newErrors.leaseName = "Lease Name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddDevice = async () => {
    setLoading(true);
    // Validate form before submission
    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      const payload = {
        companyId: process.env.REACT_APP_COMPANY_ID,
        name: unitName,
        macaddr: unitId,
        thing: "PRECISION",
        type: "agZpZGFxLTFyFwsSBVRISU5HIgxQUkVDSVNJT04uanMM",
        leaseNumber: leaseNumber,
        leaseName: leaseName,
        assets: [
          {
            groupId: parentGroup || "",
            regionId: regionDistrict || "",
            routeId: route || "",
          },
          {
            groupId: notificationGroup || "",
          },
        ],
        UI_Description: `${getUIDescription()}\n Add Device`, 
      };
      console.log("📡 Creating device with payload:", payload);
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/devices`,
        payload
      );

      if (onSubmit) {
        onSubmit(response.data);
      }
      toast.success("✅ Unit created successfully!");
      console.log("✅ Device created:", response.data);

      setTimeout(() => {
        window.location.reload();
      }, 500);
      onClose();
    } catch (error) {
      console.error(
        "❌ Error creating device:",
        error.response?.data || error.message
      );

      toast.error(error.response?.data?.message || "❌ Failed to create unit");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Clear errors when user starts typing
  const handleFieldChange = (field, value, setter) => {
    setter(value);
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Unit</DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            borderRadius: 0,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 1,
          }}
        >
          {/* Required Fields */}
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Unit Name *"
            value={
              leaseNumber + (leaseNumber || leaseName ? " " : "") + leaseName
            }
            disabled
            // onChange={(e) =>
            //   handleFieldChange("unitName", e.target.value, setUnitName)
            // }
            fullWidth
            error={!!errors.unitName}
            helperText={errors.unitName}
          />

          {/* Modem Serial Number is same as Modem Serial Number */}
          <TextField
             sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Modem Serial Number *"
            value={unitId}
            onChange={(e) =>
              handleFieldChange("unitId", e.target.value, setUnitId)
            }
            fullWidth
            error={!!errors.unitId}
            helperText={errors.unitId}
          />
          {/* Lease Number is same as Unit Number */}

          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Unit Number *"
            value={leaseNumber}
            onChange={(e) =>
              handleFieldChange("leaseNumber", e.target.value, setLeaseNumber)
            }
            fullWidth
            error={!!errors.leaseNumber}
            helperText={errors.leaseNumber}
          />

          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Lease Name *"
            value={leaseName}
            onChange={(e) =>
              handleFieldChange("leaseName", e.target.value, setLeaseName)
            }
            fullWidth
            error={!!errors.leaseName}
            helperText={errors.leaseName}
          />

          {/* Parent Group Dropdown - Required */}
          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            select
            label="Parent Group *"
            value={parentGroup}
            onChange={(e) =>
              handleFieldChange("parentGroup", e.target.value, setParentGroup)
            }
            fullWidth
            disabled={loadingGroups}
            error={!!errors.parentGroup}
            helperText={errors.parentGroup}
          >
            {groups.length > 0 ? (
              groups.map((group) => (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingGroups ? "Loading groups..." : "No groups available"}
              </MenuItem>
            )}
          </TextField>

          {/* Optional Fields */}
          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            select
            label="Region/District"
            value={regionDistrict}
            onChange={(e) => setRegionDistrict(e.target.value)}
            fullWidth
          >
            {Array.isArray(allRegions) && allRegions.length > 0 ? (
              allRegions.map((regionItem) => (
                <MenuItem key={regionItem.id} value={regionItem.id}>
                  {regionItem.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingRegions
                  ? "Loading Regions..."
                  : parentGroup
                  ? "No Regions available"
                  : "Select Parent Group first"}
              </MenuItem>
            )}
          </TextField>

          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            select
            label="Route"
            value={route}
            onChange={(e) => setRoute(e.target.value)}
            fullWidth
            disabled={loadingroutes}
          >
            <MenuItem value="">
              <em>No Route Assigned</em>
            </MenuItem>
            {Array.isArray(allRoutes) && allRoutes.length > 0 ? (
              allRoutes.map((route) => (
                <MenuItem key={route.id} value={route.id}>
                  {route.name ||
                    `${route.firstName} ${route.lastName}` ||
                    route.email}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingroutes ? "Loading routes..." : "No routes available"}
              </MenuItem>
            )}
          </TextField>
          <TextField
           sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            select
            label="Notification Group"
            value={notificationGroup}
            onChange={(e) =>
              handleFieldChange(
                "notificationGroup",
                e.target.value,
                setNotificationGroup
              )
            }
            fullWidth
            disabled={loadingNotificationGroups}
          >
            {notificationGroups.length > 0 ? (
              notificationGroups.map((group) => (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingNotificationGroups
                  ? "Loading notification groups..."
                  : "No notification groups available"}
              </MenuItem>
            )}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancel
        </Button>
        <Button
          sx={{ borderRadius: 0 }}
          onClick={handleAddDevice}
          variant="contained"
          color="primary"
          disabled={
            loading ||
            !unitName ||
            !unitId ||
            !parentGroup ||
            !leaseNumber ||
            !leaseName
          }
          startIcon={
            loading ? <CircularProgress size={18} color="inherit" /> : undefined
          }
        >
          {loading ? "Adding..." : "Add Unit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
